module.exports = __webpack_public_path__ + "img/grow_0.04b5a991.png";